export default "__VITE_ASSET__BWzXxag0__"